import * as React from "react";
import PropTypes from "prop-types";
const SvgSportsRowingNormalSmall = React.forwardRef(
  ({ color = "currentColor", size = 24, title, titleId, ...props }, ref) => (
    <svg
      fill={color}
      viewBox="0 0 24 25"
      xmlns="http://www.w3.org/2000/svg"
      ref={ref}
      width={size}
      height={size}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <path
        d="M2 0a2 2 0 00-2 2v.514a2 2 0 00.421 1.228l2.111 2.714A4 4 0 005.69 8h3.54l1.5 1.91-3.473 4.418-.713-.56-1.236 1.572.713.561L.59 22.814l1.573 1.236 5.431-6.913.714.56 1.235-1.572-.713-.561L12 11.528l3.171 4.036-.713.56 1.235 1.573.714-.56 5.432 6.913 1.572-1.236-5.432-6.913.714-.56-1.236-1.573-.713.56-3.472-4.419L14.772 8h3.538a4 4 0 003.158-1.544l2.11-2.714A2 2 0 0024 2.514V2a2 2 0 00-2-2h-2.514a2 2 0 00-1.573.764L13.5 6.382l-.005.007L12 8.29l-1.497-1.905-.002-.004L6.087.764A2 2 0 004.514 0zm0 2h2.514l3.143 4H5.689a2 2 0 01-1.578-.772L2 2.514zm17.486 0H22v.514l-2.11 2.714A2 2 0 0118.31 6h-1.967z"
        fill=""
      />
    </svg>
  )
);
SvgSportsRowingNormalSmall.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  title: PropTypes.string,
  titleId: PropTypes.string,
};
export default SvgSportsRowingNormalSmall;
